export default __webpack_public_path__ + "static/media/404-error-rafiki-1.258c5857.svg";